"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fdate_1 = require("./fdate");
/**
 * dzisiejsza data w formacie yyyy-MM-dd
 */
function today() {
    return fdate_1.default(new Date());
}
exports.default = today;
//# sourceMappingURL=today.js.map